export const WebsiteCategories = Object.freeze({
  men: 'men',
  women: 'women'
})

export const WebsiteCategoryCookie = 'ota-top-cat'

const StorageKeyPrefix = 'ota-v1-'

export const PersistentStorageKeys = Object.freeze({
  general: `${StorageKeyPrefix}general`,
  signup: `${StorageKeyPrefix}signup`,
  webshop: `${StorageKeyPrefix}webshop`
})
